import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { FreightManagerService } from 'src/app/services/freight-manager/freight-manager.service';
import { MONTH_LIST } from 'src/app/shared/data/month-list';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-copy-freight-manager',
  templateUrl: './copy-freight-manager.component.html',
  styleUrls: ['./copy-freight-manager.component.scss']
})
export class CopyFreightManagerComponent extends DestructorComponent implements OnInit  {

  @Input() activeTab: string = '';
  @Output() dataCopied = new EventEmitter<void>();

  copyForm: FormGroup;
  isLoading = false;
  monthList = MONTH_LIST;
  yearList: { value: string, label: string }[] = [];

  constructor(private fb: FormBuilder,
    private _freightManagerService: FreightManagerService
  ) {
    super();
    this.copyForm = this.fb.group({
      fromMonth: ['', Validators.required],
      fromYear: ['', Validators.required],
      toMonth: ['', Validators.required],
      toYear: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.generateYearList();
    this.setupModalListener();
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_copy_freight_manager');
    if (modalElement) {
      modalElement.addEventListener('hidden.bs.modal', () => {
        this.resetForm();
      });
    }
  }

  private generateYearList(): void {
    const currentYear = new Date().getFullYear();
    const startYear = 2020; // Start from 2020 for freight manager data

    for (let year = currentYear + 1; year >= startYear; year--) {
      this.yearList.push({ value: year.toString(), label: year.toString() });
    }
  }

  get fromMonth() { return this.copyForm.get('fromMonth'); }
  get fromYear() { return this.copyForm.get('fromYear'); }
  get toMonth() { return this.copyForm.get('toMonth'); }
  get toYear() { return this.copyForm.get('toYear'); }

  onSubmit(): void {
    if (this.copyForm.valid && !this.isLoading) {
      this.isLoading = true;

      const formData = this.copyForm.value;

      console.log("active tab : ",this.activeTab)

      const data = {
        from_month: formData.fromMonth,
        from_year: formData.fromYear,
        to_month: formData.toMonth,
        to_year: formData.toYear,
        type: this.activeTab
      };

      this.subscriptions.push(
        this._freightManagerService.CopyData(data).subscribe({
          next: (response: any) => {
            this.isLoading = false;
            if (response.status) {
              Swal.fire({
                title: 'Success!',
                text: 'Freight manager data copied successfully.',
                icon: 'success',
                confirmButtonText: 'OK'
              }).then(() => {
                this.closeModal();
                this.dataCopied.emit();
              });
            } else {
              Swal.fire({
                title: 'Error!',
                text: response.message || 'Failed to copy freight manager data.',
                icon: 'error',
                confirmButtonText: 'OK'
              });
            }
          },
          error: (error) => {
            this.isLoading = false;
            Swal.fire({
              title: 'Error!',
              text: 'Failed to copy freight manager data. Please try again.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
          }
        })
      );

    } else {
      // Show validation errors
      this.markFormGroupTouched();
    }
  }

  private markFormGroupTouched(): void {
    Object.keys(this.copyForm.controls).forEach(key => {
      const control = this.copyForm.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
  }

  closeModal(): void {
    const modalElement = document.getElementById('kt_modal_copy_freight_manager');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
    this.resetForm();
  }

  private resetForm(): void {
    this.copyForm.reset();
    this.isLoading = false;
  }
}
